import * as React from 'react';
import * as _ from 'lodash';
export default function (props, context) {
    function onClick1() {
        props.showAssignPopup(true);
    }
    function onClick2() {
        props.selectAllStones(true);
    }
    function onClick3() {
        props.selectAllStones(false);
    }
    return React.createElement('div', { 'className': 'app-content-header app-content-header--buttons app-content-header--lined' }, React.createElement('div', { 'className': 'app-content-header--buttons-left' }, React.createElement('button', {
        'className': 'ui-button4 ui-button4--green',
        'onClick': onClick1.bind(this)
    }, React.createElement('span', { 'className': 'ui-button4-icon ui-button-icon--arrow-down' }), React.createElement('span', {}, 'Assign Filters')), React.createElement('button', {
        'className': 'ui-button4 ui-button4--blue ui-button4--medium',
        'onClick': onClick2.bind(this)
    }, 'Select All'), React.createElement('button', {
        'className': 'ui-button4 ui-button4--blue ui-button4--medium',
        'onClick': onClick3.bind(this)
    }, 'Deselect All')));
}